<template>
	<div class="layer-project" data-project-name="xeogen">
		<!-- Project Name -->
		<div class="layer-project-detail">
			<!-- Page Contents -->
			<section class="project-visual">
				<div>
					<h1 class="project-tit"><span class="award18"></span>XEOGEN</h1>
					<a href="http://www.xeogen.com" class="link" target="_blank"
						>www.xeogen.com</a
					>
				</div>
			</section>
			<!-- Details [s] -->
			<section class="project-overview">
				<div class="inner-section">
					<h2 class="project-overview-tit">Overview</h2>
					<p class="project-overview-txt">
						Be Awesome, the newgame rule in the Digital world. <br />1세대
						에이전시로서 지난 20여년의 경험 및 노하우를 바탕으로 끊임없이
						변화하는 트렌드를 습득하며 <br class="blank tb" />최고의 기업들과
						국내 및 글로벌 프로젝트를 수행하고 있으며,
						<br class="blank pc" />언제나 새로운 도전을 멈추지 않고 있습니다.
					</p>
				</div>
			</section>

			<!-- Details [e] -->
			<!-- section01 -->
			<section class="section section01 full">
				<div class="inner-section">
					<div class="detail-img">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/xeogen/sec1-cont@m.png"
							data-break="m-tw"
						/>
					</div>
				</div>
			</section>
			<!-- section02 -->
			<section class="section section02">
				<div class="inner-section">
					<div class="cont-tit-area">
						<strong class="project-subtit">PC Web</strong>
					</div>
					<div class="detail-img shadow">
						<div class="content mobile-swiper">
							<div class="swiper-wrapper shadow">
								<div class="swiper-slide">
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/xeogen/sec2-cont-img01@m.jpg"
										data-break="m-tw"
									/>
								</div>
								<div class="swiper-slide">
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/xeogen/sec2-cont-img02@m.jpg"
										data-break="m-tw"
									/>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
				</div>
			</section>
			<!-- section03 -->
			<section class="section section03 full">
				<div class="inner-section">
					<div class="cont-tit-area max-limit">
						<strong class="project-subtit">Mobile Web</strong>
					</div>
					<div class="detail-img">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/xeogen/sec3-cont01@m.png"
						/>
					</div>
					<div class="detail-cont icon">
						<p>
							<img
								src="/static/img/project-detail/xeogen/sec3-cont02-icon01.png"
							/>
						</p>
						<p>
							<img
								src="/static/img/project-detail/xeogen/sec3-cont02-icon02.png"
							/>
						</p>
						<p>
							<img
								src="/static/img/project-detail/xeogen/sec3-cont02-icon03.png"
							/>
						</p>
						<p>
							<img
								src="/static/img/project-detail/xeogen/sec3-cont02-icon04.png"
							/>
						</p>
					</div>
				</div>
			</section>
			<section class="project-client">
				<strong class="a11y-hidden">CREATIVE GROUP XEOGEN</strong>
			</section>
			<!-- Page Contents -->
		</div>

		<app-pjmove></app-pjmove>
	</div>
</template>

<script>
import Swiper from "../../static/js/swiper.min.js"; /* if use swiper.min.js */
import pjMove from "../components/pjMove.vue";
import projectCommon from "../assets/js/projectCommon.js";

export default {
	components: {
		"app-pjmove": pjMove,
	},
	mixins: [projectCommon],
	mounted: function () {
		//onload
		this.projectInit();

		var $window = $(window);
		var winW = $window.outerWidth();
		var flag = true;
		var isSlider = true;
		var pcwebSwiper;

		var pcWeb = function () {
			if (isSlider) {
				isSlider = false;
				pcwebSwiper = new Swiper(".mobile-swiper", {
					spaceBetween: 15,
					pagination: {
						el: ".swiper-pagination",
						clickable: true,
					},
				});
			}
		};

		if (winW < 712) {
			pcWeb();
		} else {
			isSlider = true;
		}
		$window.off("resize").on("resize", function () {
			winW = $(this).outerWidth();
			if (winW < 712) {
				if (flag) {
					flag = false;
					pcWeb();
				}
			} else {
				flag = true;
				if (!isSlider) {
					isSlider = true;
					pcwebSwiper.destroy();
					$(".swiper-pagination").children().remove();
				}
			}
		});
	},
	methods: {},
};
</script>

<style scoped>
@import "../../static/css/projects.css"; /* Common Project Detail Page */
/* Common */
div[class^="rwd"] {
	display: none;
}
.project-subtit {
	line-height: 1.2;
}
.section.full .con-tit-area {
	max-width: 1280px;
	margin: 0 auto;
}
.section .cont-tit-area {
	word-break: keep-all;
}
.section .detail-img {
	text-align: center;
}
.section p {
	word-break: keep-all;
}
.blank {
	display: none;
}
@media screen and (max-width: 711px) {
	div[class="rwd-mb"] {
		display: inline-block;
	}
	.project-subtit {
		text-align: center;
	}
	.section.full .max-limit {
		padding-left: 15px;
		padding-right: 15px;
	}
	.blank.mb {
		display: block;
	}
	.shadow img {
		box-shadow: 31px 4px 51px 0px rgba(0, 0, 0, 0.21);
	}
}
@media screen and (min-width: 712px) {
	div[class="rwd-tb"] {
		display: inline-block;
	}
	.section .project-subtit {
		font-size: 2.2rem;
	}
	.section.full .max-limit {
		padding-left: 40px;
		padding-right: 40px;
	}
	.blank.tb {
		display: block;
	}
	.shadow img {
		box-shadow: 31px 4px 51px 0px rgba(0, 0, 0, 0.21);
	}
}
@media screen and (min-width: 1280px) {
	div[class="rwd-tb"] {
		display: none;
	}
	div[class="rwd-pc"] {
		display: inline-block;
	}
	.section.full {
		max-width: 1920px;
	}
	.section.full .max-limit {
		max-width: 1280px;
		margin: 0 auto;
		padding-left: 20px;
		padding-right: 20px;
	}
	.section .project-subtit {
		font-size: 56px;
	}
	.blank.tb {
		display: none;
	}
	.blank.pc {
		display: block;
	}
}

/* Project Visual, Project CI */
.project-client {
	background: #2d2d2c url(/static/img/project-detail/xeogen/ci.png) 50% / auto
		77px no-repeat;
}
@media screen and (max-width: 711px) {
	.project-visual {
		background-image: url(/static/img/project-detail/xeogen/bg-overview@m.jpg);
	}
}
@media screen and (min-width: 712px) {
	.project-visual {
		background-image: url(/static/img/project-detail/xeogen/bg-overview@t.jpg);
	}
}
@media screen and (min-width: 1280px) {
	.project-visual {
		background-image: url(/static/img/project-detail/xeogen/bg-overview@w.jpg);
	}
	.project-client {
		background-size: auto 192px;
	}
}

/* Overview */
.project-overview {
	background-color: #e9382c;
	color: #fff;
}
@media screen and (max-width: 711px) {
	.project-overview p {
		padding-bottom: 10px;
	}
}
@media screen and (min-width: 712px) {
	.project-overview p {
		padding-bottom: 20px;
	}
}
@media screen and (min-width: 1280px) {
	.project-overview .project-overview-tit {
		padding-top: 50px;
	}
	.project-overview p {
		padding-bottom: 40px;
	}
}

/* section01 */
.section01 {
	background-color: #ebebeb;
}
.section01 .detail-img {
	background: url(/static/img/project-detail/xeogen/sec1-cont-bg.png) no-repeat;
	text-align: right;
}
@media screen and (max-width: 711px) {
	.section01 .detail-img {
		padding-top: 25px;
		background-size: 61.4vw;
		background-position: -45% 100%;
	}
	.section01 .detail-img img {
		width: 81.4vw;
	}
}
@media screen and (min-width: 712px) {
	.section01 .detail-img {
		padding: 20px 0;
		background-size: 42.7vw;
		background-position: -24% 57%;
	}
	.section01 .detail-img img {
		width: 65.87vw;
	}
}
@media screen and (min-width: 1280px) {
	.layer-project-detail > .section01.full {
		padding-bottom: 0;
	}
	.section01 .detail-img {
		margin-bottom: -12px;
		padding: 130px 0 0;
		background-size: 775px;
		background-position: -195px 470px;
	}
	.section01 .detail-img img {
		width: auto;
	}
}

/* section02 */
.section02 {
	position: relative;
	padding-bottom: 60px;
	background-color: #2d2d2c;
}
.section02::after {
	content: "";
	position: absolute;
	bottom: -5vw;
	left: calc(50% - 60vw);
	display: block;
	width: 150vw;
	background-color: #dad9d6;
	transform: rotate(-5deg);
}
.section02 .project-subtit {
	color: #fff;
}
@media screen and (max-width: 711px) {
	.section02::after {
		height: 120vw;
	}
	.section02 .cont-tit-area {
		padding-bottom: 15px;
	}
	/* .section02 .swiper-slide{display:inline-flex;justify-content:center;flex-direction:column;min-height:151.2vw} */
}
@media screen and (min-width: 712px) {
	.section02 {
		overflow: hidden;
	}
	.section02::after {
		height: 46.52vw;
	}
	.section02 .cont-tit-area {
		padding: 30px 0;
	}
	.section02 .swiper-wrapper {
		display: flex;
		justify-content: flex-start;
	}
	.section02 .swiper-slide {
		margin-right: 20px;
	}
	.section02 .swiper-slide:nth-child(1) {
		width: 47vw;
	}
	.section02 .swiper-slide:nth-child(2) {
		width: 45.4vw;
	}
}
@media screen and (min-width: 1280px) {
	.section02 .cont-tit-area {
		padding: 100px 0 65px;
	}
	.section02 .swiper-slide {
		margin-right: 30px;
	}
	.section02 .swiper-slide:nth-child(1),
	.section02 .swiper-slide:nth-child(2) {
		width: auto;
	}
}

/* section03 */
.section03 {
	background-color: #dad9d6;
}
.section03 .detail-cont {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
}
@media screen and (max-width: 711px) {
	.section03 .cont-tit-area {
		margin-top: 15px;
	}
	.section03 .detail-img {
		padding: 10px 0;
	}
	.section03 .detail-cont {
		padding: 10px 0;
	}
	.section03 .detail-cont p {
		width: 14.21vw;
		height: 6.59vw;
		margin: 45px 45px 0;
	}
}
@media screen and (min-width: 712px) {
	.layer-project-detail > .section03.full {
		padding-top: 20px;
	}
	.section03 .detail-img {
		padding: 15px 0;
	}
	.section03 .detail-img img {
		width: 80.68vw;
	}
	.section03 .detail-cont {
		padding: 45px 0 25px;
	}
	.section03 .detail-cont p {
		width: 4.56vw;
		height: auto;
		margin: 0 30px;
	}
}
@media screen and (min-width: 1280px) {
	.section03 .detail-img img {
		width: auto;
	}
	.section03 .detail-cont {
		width: auto;
		padding: 120px 0 110px;
	}
	.section03 .detail-cont p {
		width: auto;
		margin: 0 70px;
	}
}
</style>



// WEBPACK FOOTER //
// src/projects/xeogen.vue